import common from './greenTheme/commonStyle.oci';
import portrait from './greenTheme/portrait.oci';
import landscape from './greenTheme/landscape.oci';
export let commonStyles = common;
export let portraitStyles = portrait;
export let landscapeStyle = landscape;
